export const capitalize = (str: string): string => {
  const _str = String(str);
  return _str.charAt(0).toUpperCase() + _str.slice(1).toLowerCase();
};
